import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Partner pages
export const PartnerListPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/partners/list')) as Promise<
      typeof import('@pages/management/portafolio/partners/list')
    >
);

export const PartnerCreatePage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/partners/create')) as Promise<
      typeof import('@pages/management/portafolio/partners/create')
    >
);

export const PartnerEditPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/partners/edit')) as Promise<
      typeof import('@pages/management/portafolio/partners/edit')
    >
);

export const PartnerTabsPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/partners/tabs')) as Promise<
      typeof import('@pages/management/portafolio/partners/tabs')
    >
);

export const PartnerContactCreatePage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/partners/contact-create')) as Promise<
      typeof import('@pages/management/portafolio/partners/contact-create')
    >
);

export const PartnerContactEditPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/partners/contact-edit')) as Promise<
      typeof import('@pages/management/portafolio/partners/contact-edit')
    >
);

export const PartnerInformationEditPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/partners/information-edit')) as Promise<
      typeof import('@pages/management/portafolio/partners/information-edit')
    >
);

export const PartnerProviderCreatePage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/partners/provider-create')) as Promise<
      typeof import('@pages/management/portafolio/partners/provider-create')
    >
);

export const PartnerProviderEditPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/partners/provider-edit')) as Promise<
      typeof import('@pages/management/portafolio/partners/provider-edit')
    >
);

// Product pages
export const ProductListPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/products/list')) as Promise<
      typeof import('@pages/management/portafolio/products/list')
    >
);

export const ProductInformationPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/products/information')) as Promise<
      typeof import('@pages/management/portafolio/products/information')
    >
);

export const ProductSKUsPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/products/skus')) as Promise<
      typeof import('@pages/management/portafolio/products/skus')
    >
);

export const ProductCreatePage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/products/create')) as Promise<
      typeof import('@pages/management/portafolio/products/create')
    >
);

export const ProductEditPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/products/edit')) as Promise<
      typeof import('@pages/management/portafolio/products/edit')
    >
);

// SKU pages
export const SkuListPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/skus/list')) as Promise<
      typeof import('@pages/management/portafolio/skus/list')
    >
);

export const SkuCreatePage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/skus/create')) as Promise<
      typeof import('@pages/management/portafolio/skus/create')
    >
);

export const SkuEditPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/skus/edit')) as Promise<
      typeof import('@pages/management/portafolio/skus/edit')
    >
);

export const SkuInformationPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/skus/information')) as Promise<
      typeof import('@pages/management/portafolio/skus/information')
    >
);

export const SkuPlansPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/skus/plans')) as Promise<
      typeof import('@pages/management/portafolio/skus/plans')
    >
);

// Plan pages
export const PlanListPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/plans/list')) as Promise<
      typeof import('@pages/management/portafolio/plans/list')
    >
);

export const PlanCreatePage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/plans/create')) as Promise<
      typeof import('@pages/management/portafolio/plans/create')
    >
);

export const PlanEditPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/plans/edit')) as Promise<
      typeof import('@pages/management/portafolio/plans/edit')
    >
);

export const PlanInformationPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/plans/information')) as Promise<
      typeof import('@pages/management/portafolio/plans/information')
    >
);

export const PlanSubscriptionPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/plans/subscription')) as Promise<
      typeof import('@pages/management/portafolio/plans/subscription')
    >
);

// Pricebook pages
export const PricebookListPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/pricebook/list')) as Promise<
      typeof import('@pages/management/portafolio/pricebook/list')
    >
);

export const PricebookCreatePage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/pricebook/create')) as Promise<
      typeof import('@pages/management/portafolio/pricebook/create')
    >
);

export const PricebookEditPage = lazy(
  () =>
    retry(() => import('@pages/management/portafolio/pricebook/edit')) as Promise<
      typeof import('@pages/management/portafolio/pricebook/edit')
    >
);
